module.exports = __webpack_public_path__ + "img/wechat-pay.592b2a5b.png";